export const environment = {
  production: true,
  environmentName: 'aws-prod',
  apiUrl: 'https://api.contaplus.cr'
};
